import {useState,useEffect} from 'react';
import Hero from '../components/Hero';
import Events from '../content/events';
import { useLanguage } from '../i18n/LanguageContext';


export default function NewsAndEvents() {
  const { strings } = useLanguage();

 

  return (
      <div className="main">
      <Hero title={strings.pages.news_and_events.title} eyebrow={strings.pages.news_and_events.eyebrow} />
      <main className="page-content">
        
          <div className="content-table max-centered">
              <div className="content-container">    
                  <div className="content-container-main show" id="content-container-main">
                   <Events lang={strings.lang_code}/>     
              </div>
            </div>
       </div>
      </main>
    </div>
  );
}